module.exports = __webpack_public_path__ + "media/images/client-11-a2d8cf7c13ac9786ae929d298ada1d7b.png";